import { useEffect, useState } from 'react';
import { getPeriodInfo, type PeriodInfo } from '@/lib/time';

/**
 * Live meal-period info (breakfast / lunch / dinner / latenight) based on
 * East Africa Time. Re-checks every 30 seconds so the greeting stays fresh.
 */
export function useMealPeriod(): PeriodInfo {
  const [info, setInfo] = useState<PeriodInfo>(() => getPeriodInfo());

  useEffect(() => {
    const id = setInterval(() => {
      setInfo((current) => {
        const next = getPeriodInfo();
        return next.period === current.period ? current : next;
      });
    }, 30_000);
    return () => clearInterval(id);
  }, []);

  return info;
}
